/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RotorWingCalendarResponse } from '../../models/rotor-wing-calendar-response';

export interface GetRotorWingCalendar$Params {
  dateFrom: string;
  dateTo: string;
  base?: string;
}

export function getRotorWingCalendar(http: HttpClient, rootUrl: string, params: GetRotorWingCalendar$Params, context?: HttpContext): Observable<StrictHttpResponse<RotorWingCalendarResponse>> {
  const rb = new RequestBuilder(rootUrl, getRotorWingCalendar.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('base', params.base, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RotorWingCalendarResponse>;
    })
  );
}

getRotorWingCalendar.PATH = '/api/scheduler/daily-line-schedule/rotor-wing/calendar';
